import React, { useEffect, useState } from "react";
import { Button, Input, Table, Tooltip, message } from "antd";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { BsSearch, BsX } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";

import {
  asyncDeleteAllMeetingPoint,
  asyncDeleteMeetingPoint,
  asyncDeleteSelectedMeetingPoint,
  asyncGetMeetingPoint,
  asyncImportMeetingPoint,
} from "../redux/slices/meetingPointSlice";
import ImportModal from "../components/modules/importModal";
import ConfirmationModal from "../components/common/confirmationModal";
import MeetingPointModal from "../components/modules/meetingPoint/meetingPointModal";
import ImportReportMeetingPoint from "../components/modules/meetingPoint/importReport";

const { Column } = Table;

const MeetingPoints = () => {
  const dispatch = useDispatch();
  const {
    loading,
    data,
    pagination,
    deleteLoading,
    importLoading,
    deleteAllLoading,
    deleteSelectedLoading,
  } = useSelector((state) => ({
    loading: state.meetingPoint.getMeetingPoint.loading,
    data: state.meetingPoint.getMeetingPoint.data,
    pagination: state.meetingPoint.getMeetingPoint.pagination,
    deleteLoading: state.meetingPoint.deleteMeetingPoint.loading,
    importLoading: state.meetingPoint.importMeetingPoint.loading,
    deleteAllLoading: state.meetingPoint.deleteAllMeetingPoint.loading,
    deleteSelectedLoading:
      state.meetingPoint.deleteSelectedMeetingPoint.loading,
  }));

  const initModalData = {
    name: "",
    latitude: "",
    longitude: "",
  };

  const [currentColumn, setCurrentColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchText, setSearchText] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [openImportModal, setOpenImportModal] = useState(false);
  const [modalData, setModalData] = useState({
    mode: "",
    data: initModalData,
  });
  const [file, setFile] = useState(null);
  const [openModalReport, setOpenModalReport] = useState(false);
  const [errorData, setErrorData] = useState([]);
  const [successData, setSuccessData] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isDeleteAll, setIsDeleteAll] = useState(false);
  const [isDeleteSelected, setIsDeleteSelected] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const header = () => {
    return (
      <div>
        <div className="table_header">
          <div className="button_margin">
            <Input
              placeholder={"Search Meeting Point"}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="search_input"
              prefix={<BsSearch />}
              suffix={
                searchText && (
                  <BsX
                    style={{ cursor: "pointer" }}
                    onClick={() => setSearchText("")}
                  />
                )
              }
            />
          </div>
          <div className="table_header_button">
            <Button
              className="button_margin"
              onClick={() => {
                setOpenImportModal(true);
              }}
            >
              Import
            </Button>
            <Button
              className="button_margin"
              onClick={() => {
                const filePath = "/sampleSheet/sample_meeting_points.csv";
                window.open(filePath, "_blank");
              }}
            >
              Download Import Template
            </Button>
            <Button
              onClick={() => {
                setOpenModal(true);
                setModalData({
                  mode: "add",
                  data: initModalData,
                });
              }}
            >
              Create New
            </Button>
          </div>
        </div>
        <div className="table_header_down">
          {pagination?.totalItems > 0 && (
            <Button
              className="button_margin"
              onClick={() => {
                setIsDeleteAll(true);
              }}
            >
              {`Delete all available data`}
            </Button>
          )}
          {selectedIds.length > 0 && (
            <Button
              className="button_margin"
              onClick={() => {
                setIsDeleteSelected(true);
              }}
            >
              {`Delete selected (${selectedIds.length}) data`}
            </Button>
          )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (!isInitialRender) {
      const delay = 500;
      const timeoutId = setTimeout(() => {
        dispatch(
          asyncGetMeetingPoint({
            page: 1,
            limit: 10,
            q: searchText,
          })
        );
      }, delay);
      return () => clearTimeout(timeoutId);
    } else {
      setIsInitialRender(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const handleSubmit = () => {
    setOpenModalReport(false);
    setErrorData([]);
    setSuccessData([]);
    if (file) {
      const formData = new FormData();
      formData.append("upload", file);
      formData.append("isChecked", isChecked || false);

      dispatch(asyncImportMeetingPoint(formData)).then((res) => {
        if (res.payload?.status === 200) {
          if (res.payload.data) {
            setErrorData(res.payload.data?.errorData || []);
            setSuccessData(res.payload.data?.newResponse || []);
            setOpenModalReport(true);
          }
          setOpenImportModal(false);
          messageApi.open({
            type: "success",
            content: res.payload?.data?.message,
          });
          dispatch(
            asyncGetMeetingPoint({
              page: 1,
              limit: 10,
            })
          );
          setFile(null);
          setIsChecked(false);
        } else {
          setOpenImportModal(false);
          messageApi.open({
            type: "error",
            content: res.payload?.message,
          });
          setFile(null);
          setIsChecked(false);
        }
      });
    } else {
      setOpenImportModal(false);
      messageApi.open({
        type: "error",
        content: "Please select file",
      });
      setIsChecked(false);
    }
  };

  const handleDelete = () => {
    if (deleteId) {
      dispatch(asyncDeleteMeetingPoint(deleteId)).then((res) => {
        setConfirmation(false);
        if (res.payload?.status === 200) {
          messageApi.open({
            type: "success",
            content: res.payload?.data?.message,
          });
          dispatch(
            asyncGetMeetingPoint({
              page: pagination.page || 1,
              limit: pagination.pageSize || 10,
              q: searchText,
            })
          );
          setDeleteId(0);
        } else {
          setConfirmation(false);
          messageApi.open({
            type: "error",
            content: res.payload?.message,
          });
        }
      });
    }
  };

  const handleDeleteAll = () => {
    dispatch(asyncDeleteAllMeetingPoint()).then((res) => {
      setIsDeleteAll(false);
      if (res.payload?.status === 200) {
        messageApi.open({
          type: "success",
          content: res.payload?.data?.message,
        });
        dispatch(
          asyncGetMeetingPoint({
            page: pagination.page || 1,
            limit: pagination.pageSize || 10,
            q: searchText,
          })
        );
      } else {
        setIsDeleteAll(false);
        messageApi.open({
          type: "error",
          content: res.payload?.message,
        });
      }
    });
  };

  const handleDeleteSelected = () => {
    dispatch(asyncDeleteSelectedMeetingPoint({ ids: selectedIds ?? [] })).then(
      (res) => {
        setIsDeleteSelected(false);
        if (res.payload?.status === 200) {
          messageApi.open({
            type: "success",
            content: res.payload?.data?.message,
          });
          setSelectedIds([]);
          dispatch(
            asyncGetMeetingPoint({
              page: pagination.page || 1,
              limit: pagination.pageSize || 10,
              q: searchText,
            })
          );
        } else {
          setIsDeleteSelected(false);
          messageApi.open({
            type: "error",
            content: res.payload?.message,
          });
        }
      }
    );
  };

  const fetchData = (page, pageSize, sortOrder, column) => {
    dispatch(
      asyncGetMeetingPoint({
        page,
        limit: pageSize,
        sortOrder: sortOrder,
        sortByColumn: column,
        q: searchText,
      })
    );
  };

  const handleSort = (column) => {
    let newSortOrder;

    if (column !== currentColumn) {
      newSortOrder = "ASC";
    } else {
      if (sortOrder === "ASC") {
        newSortOrder = "DESC";
      } else if (sortOrder === "DESC") {
        newSortOrder = "";
      } else {
        newSortOrder = "ASC";
      }
    }

    setSortOrder(newSortOrder);
    setCurrentColumn(column);
    fetchData(1, 10, newSortOrder, column);
  };

  const onPageChange = (page, pageSize) => {
    fetchData(page, pageSize, sortOrder, currentColumn);
  };

  useEffect(() => {
    dispatch(
      asyncGetMeetingPoint({
        page: pagination.page,
        limit: pagination.pageSize,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedIds(selectedRowKeys);
    },
  };

  return (
    <div>
      {contextHolder}
      <div className="table_name">Meeting Points</div>
      <div>{header()}</div>
      <Table
        rowKey={(record) => record?.id}
        rowSelection={Object.assign({ type: "checkbox" }, rowSelection)}
        dataSource={data}
        bordered
        size="small"
        loading={loading}
        // scroll={{ y: 400 }}
        pagination={{
          current: pagination.page,
          pageSize: pagination.pageSize,
          total: pagination?.totalItems,
          onChange: (page, pageSize) => {
            onPageChange(page, pageSize);
          },
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
          // locale: { items_per_page: 'per page' },
        }}
      >
        <Column
          title="Name"
          key="name"
          render={(record) => record?.name}
          sorter={true}
          onHeaderCell={() => ({
            onClick: () => handleSort("name"),
          })}
        />

        <Column
          title="Code"
          key="name"
          render={(record) =>
            record && record.name
              ? record.name.split(",").length > 3
                ? record.name + "-" + record.name.split(",")[1]
                : record.name + "-" + record.name.split(",")[0]
              : ""
          }
          sorter={true}
          onHeaderCell={() => ({
            onClick: () => handleSort("name"),
          })}
        />

        <Column
          title="Longitude"
          key="longitude"
          render={(record) => record?.longitude}
          sorter={true}
          onHeaderCell={() => ({
            onClick: () => handleSort("longitude"),
          })}
        />
        <Column
          title="Latitude"
          key="latitude"
          render={(record) => record?.latitude}
          sorter={true}
          onHeaderCell={() => ({
            onClick: () => handleSort("latitude"),
          })}
        />

        <Column
          title="Action"
          key="action"
          width="10%"
          align="center"
          render={(rowData) => (
            <div className="table_icon">
              <Tooltip title="Edit">
                <i
                  onClick={() => {
                    setOpenModal(true);
                    setModalData({
                      mode: "edit",
                      data: rowData,
                    });
                  }}
                >
                  <AiFillEdit size={20} className="edit_icon" />
                </i>
              </Tooltip>
              <Tooltip title="Delete">
                <i
                  onClick={() => {
                    setConfirmation(true);
                    setDeleteId(rowData?.id);
                  }}
                >
                  <AiFillDelete size={20} className="delete_icon" />
                </i>
              </Tooltip>
            </div>
          )}
        />
      </Table>
      {openModal && (
        <MeetingPointModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          messageApi={messageApi}
          modalData={modalData}
        />
      )}
      {openImportModal && (
        <ImportModal
          openModal={openImportModal}
          setOpenModal={setOpenImportModal}
          setFile={setFile}
          handleSubmit={handleSubmit}
          loading={importLoading}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          isCheckboxShow={true}
        />
      )}
      {confirmation && (
        <ConfirmationModal
          title={"Delete Meeting Point"}
          open={confirmation}
          setOpen={setConfirmation}
          onYes={handleDelete}
          loading={deleteLoading}
        />
      )}
      {isDeleteAll && (
        <ConfirmationModal
          title={"Delete Meeting Point"}
          message={
            "Are you sure you want to delete all available meeting points?"
          }
          open={isDeleteAll}
          setOpen={setIsDeleteAll}
          onYes={handleDeleteAll}
          loading={deleteAllLoading}
        />
      )}
      {isDeleteSelected && (
        <ConfirmationModal
          title={"Delete Meeting Point"}
          message={"Are you sure you want to delete selected meeting points?"}
          open={isDeleteSelected}
          setOpen={setIsDeleteSelected}
          onYes={handleDeleteSelected}
          loading={deleteSelectedLoading}
        />
      )}
      {openModalReport && (
        <ImportReportMeetingPoint
          openModal={openModalReport}
          setOpenModal={setOpenModalReport}
          errorData={errorData}
          successData={successData}
        />
      )}
    </div>
  );
};

export default MeetingPoints;
